
export const defaultSettings = {
    themeMode: "light",
    themeContrast: 'default',
    themeLayout: 'vertical',
    themeColorPresets: 'default',
    themeStretch: true,
};
